import { BrowserRouter, Route, Routes } from "react-router-dom";
import {
  AccountPage,
  BlogPage,
  CategoriesPage,
  CitiesPage,
  LoginPage,
  ServicePage,
  SettingsPage,
  NotFound,
  CreateUpdatePost,
  CreateUpdateFAQ,
  FAQPage,
  CreateUpdateClientFAQ,
  ClientFAQPage,
  AIBlogPage,
  CreateUpdateAiPost
} from "./pages";

const App = () => {
  
  return (
    <BrowserRouter>
        <Routes>
          <Route Component={BlogPage} path="/" />
          <Route Component={CreateUpdatePost} path="/post" />
          <Route Component={CreateUpdatePost} path="/post/:id" />
          <Route Component={AIBlogPage} path="/ai-blog" />
          <Route Component={CreateUpdateAiPost} path="/ai-blog/post" />
          <Route Component={CreateUpdateAiPost} path="/ai-blog/post/:id" />
          <Route Component={FAQPage} path="/faqs" />
          <Route Component={CreateUpdateFAQ} path="/faq" />
          <Route Component={CreateUpdateFAQ} path="/faq/:id" />
          <Route Component={ClientFAQPage} path="/client-faqs" />
          <Route Component={CreateUpdateClientFAQ} path="/client-faq" />
          <Route Component={CreateUpdateClientFAQ} path="/client-faq/:id" />
          <Route Component={LoginPage} path="/login" />
          <Route Component={AccountPage} path="/account" exact />
          <Route Component={CategoriesPage} path="/categories" />
          <Route Component={CitiesPage} path="/cities" />
          <Route Component={ServicePage} path="/service-names" />
          <Route Component={SettingsPage} path="/settings" />
          <Route Component={SettingsPage} path="/ai-blog" />
          
          <Route Component={NotFound} path="*" />
        </Routes>
    </BrowserRouter>
  );
};

export default App;
